module.exports = __webpack_public_path__ + "images/365-logo-small.png";